import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Alert from "@mui/material/Alert";
import { enqueueSnackbar } from "notistack";
import LogoContainer from "./LogoContainer";
import {
  otp_verification,
  two_Step_verification,
} from "../../../DAL/auth/auth";
import { TextField, Button, Box, Typography } from "@mui/material";
import { useAdminContext } from "../../../hooks/UseAdminContext";
import DashboardHeader from "../../headers/DashboardHeader";

export default function OTPVerification() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [timer, setTimer] = useState(120);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  console.log(state, "statestatestate");

  const [loginStates, setLoginStates] = useState({
    verification_code: "",
  });

  const { type } = useParams();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = React.useState({ verification_code: "" });
  const { userInfo } = useAdminContext();

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (value.length > 6) {
      setErrors((prev) => ({
        ...prev,
        verification_code: "You can only type a 6-digit OTP",
      }));
      return;
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
    setLoginStates({ ...loginStates, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let selectedValue =
      type === "email" ? userInfo?.user_info?.email : userInfo?.contact_number;

    const data = {
      source_type: type,
      source: selectedValue,
      verification_code: loginStates.verification_code,
    };

    if (type === "phone_number") {
      data.email = userInfo?.user_info?.email;
    }

    const response = await otp_verification(data);

    if (response.code === 200) {
      localStorage.setItem("code-verified", "298RHS1C082HINC200WIEHF1");
      if (state) {
        enqueueSnackbar("Login Successful", {
          variant: "success",
          autoHideDuration: 500,
        });
      } else {
        enqueueSnackbar("Sign up Successful", {
          variant: "success",
          autoHideDuration: 500,
        });
      }

      setLoading(false);
      if (state?.is_login) {
        navigate("/dashboard");
      } else {
        navigate("/termsofuse");
      }
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
    }
  };

  const handleResendOTP = async (e) => {
    e.preventDefault();
    setIsResendDisabled(true);
    setTimer(120);
    localStorage.removeItem("type");
    let selectedValue =
      type === "email" ? userInfo?.user_info?.email : userInfo?.contact_number;
    const data = {
      source_type: type,
      source: selectedValue,
      login_by: state?.is_login ? "login" : "sign_up",
    };

    if (type === "phone_number") {
      data.email = userInfo?.user_info?.email;
    }

    const response = await two_Step_verification(data);
    if (response.code === 200) {
      enqueueSnackbar("OTP resent successfully!", { variant: "success" });
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  useEffect(() => {
    let interval = null;

    if (isResendDisabled && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    if (timer === 0) {
      setIsResendDisabled(false);
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [timer, isResendDisabled]);

  return (
    <div className="header-container">
      <DashboardHeader />
      <div className="pageContainer">
        <LogoContainer />
        <div style={styles.formContainer}>
          <div style={styles.formContent}>
            <h2 style={styles.signInTitle}>
              Verification code has been sent to your provided{" "}
              {type === "phone_number" ? "mobile number" : "email ID"}
            </h2>

            <Alert>
              Your OTP has been successfully sent to your{" "}
              {type === "phone_number" ? "mobile number" : "email"}.
            </Alert>

            <form onSubmit={handleSubmit} className="mt-3">
              {type === "email" && (
                <Box mb={2}>
                  <TextField
                    label="Email"
                    placeholder="Your registered email"
                    fullWidth
                    required
                    type="email"
                    disabled
                    name="email"
                    value={userInfo?.user_info?.email}
                    InputLabelProps={{
                      shrink: Boolean(userInfo?.user_info?.email),
                    }}
                  />
                </Box>
              )}

              {type === "phone_number" && (
                <Box mb={2}>
                  <TextField
                    label="Mobile Number"
                    placeholder="Your mobile number"
                    fullWidth
                    required
                    type="tel"
                    disabled
                    name="phoneNumber"
                    value={userInfo?.contact_number}
                    InputLabelProps={{
                      shrink: Boolean(userInfo?.contact_number),
                    }}
                  />
                </Box>
              )}

              <Box mb={2}>
                <TextField
                  label="Verification Code"
                  fullWidth
                  required
                  name="verification_code"
                  type="number"
                  value={loginStates.verification_code}
                  onChange={handleChange}
                  error={!!errors.verification_code}
                  helperText={errors.verification_code}
                />
              </Box>

              <Box mb={2} textAlign="end">
                {isResendDisabled ? (
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "14px", color: "#555" }}
                  >
                    You can resend the code in{" "}
                    <strong>
                      {Math.floor(timer / 60)}:
                      {String(timer % 60).padStart(2, "0")}
                    </strong>
                  </Typography>
                ) : (
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "14px", color: "#555" }}
                  >
                    Didn’t receive the code?{" "}
                    <span
                      style={{
                        color: "#1976d2",
                        cursor: "pointer",
                        fontWeight: 500,
                      }}
                      type="button"
                      onClick={handleResendOTP}
                    >
                      Resend OTP
                    </span>
                  </Typography>
                )}
              </Box>

              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={loading}
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </Button>
            </form>
            <div className="mt-3 text-end">
              <Button className="w-100" onClick={() => navigate(-1)}>
                Change Verification Method
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  logoImage: {
    width: "100%",
    maxWidth: "500px",
    height: "auto",
    marginBottom: "30px",
    objectFit: "contain",
  },
  logoTitle: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "10px",
  },
  logoSubtitle: {
    fontSize: "1.5rem",
    color: "#555",
    fontWeight: "normal",
  },
  formContainer: {
    flex: 1.4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
    backgroundColor: "#f5f5f5",
  },
  formContent: {
    width: "100%",
    maxWidth: "400px",
  },
  signInTitle: {
    // fontSize: "1.8rem",
    // fontWeight: "bold",
    marginBottom: "20px",
    color: "#333",
  },
  form: {
    width: "100%",
  },
  formGroup: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "500",
    color: "#333",
  },
  input: {
    width: "100%",
    padding: "12px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "16px",
    boxSizing: "border-box",
  },
  visibilityToggle: {
    position: "absolute",
    right: "10px",
    top: "38px",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#666",
  },
  forgotPasswordContainer: {
    textAlign: "right",
    marginBottom: "20px",
  },
  forgotPasswordLink: {
    color: "#15978a",
    textDecoration: "none",
    fontSize: "14px",
  },
  submitButton: {
    width: "100%",
    padding: "14px",
    backgroundColor: "#C",
    color: "white",
    border: "none",
    borderRadius: "4px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    marginBottom: "20px",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "var(--portal-red-colr)",
    },
  },
  signUpContainer: {
    textAlign: "center",
    marginTop: "20px",
  },
  signUpText: {
    color: "#555",
    fontSize: "14px",
    marginBottom: "0", // remove spacing between lines
  },

  signUpLink: {
    color: "#15978a",
    textDecoration: "none",
    fontWeight: "bold",
    marginLeft: "5px",
  },
};
